import { Component, Input } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { AddressOutput } from '../../enums/address-output';
import { DirectoryAssistance } from '../../enums/directory-assistance';
import { ElectronicInfo } from '../../enums/electronic-info';
import { NumberUsage } from '../../enums/number-usage';
import { SearchIndex } from '../../enums/search-index';
import { WhitePages } from '../../enums/white-pages';
import { PhoneBookEntry } from '../../models/phone-book-entry';
import { PhoneNumber } from '../../models/phone-number';

let nextUniqueId = 0;

@Component({
    selector: 'app-phone-book-entry-form',
    templateUrl: './phone-book-entry-form.component.html',
    styleUrls: ['./phone-book-entry-form.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class PhoneBookEntryFormComponent {
    /**
     * Unique id
     */
    public id: number = nextUniqueId++;

    /**
     * Phone book entry
     */
    @Input()
    public item: PhoneBookEntry;

    /**
     * Disabled?
     */
    @Input()
    public disabled: boolean;

    /**
     * Readonly?
     */
    @Input()
    public readonly: boolean;

    /**
     * SearchIndex enum type 
     */
    public SearchIndex: typeof SearchIndex = SearchIndex;

    /**
     * AddressOutput enum type 
     */
    public AddressOutput: typeof AddressOutput = AddressOutput;

    /**
     * NumberUsage enum type 
     */
    public NumberUsage: typeof NumberUsage = NumberUsage;

    /**
     * DirectoryAssistance enum type 
     */
    public DirectoryAssistance: typeof DirectoryAssistance = DirectoryAssistance;

    /**
     * WhitePages enum type 
     */
    public WhitePages: typeof WhitePages = WhitePages;

    /**
     * ElectronicInfo enum type 
     */
    public ElectronicInfo: typeof ElectronicInfo = ElectronicInfo;

    /**
     * Sets phone number
     * @param phoneNumber 
     */
    public setPhoneNumber(phoneNumber: PhoneNumber): void {
        this.item.phoneNumber = Object.assign(phoneNumber, { id: 0 });
    }
}